// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"1e17f113","455":"44dde63a","977":"29f78a79"}[chunkId] + ".chunk.js";
};